import styled from 'styled-components';
import * as CSS from 'csstype';
import {
  accentColorPrim,
  accentColorTertiary,
  red,
  white,
} from '../../assets/styledAssets/vars';
import { Link } from 'react-router-dom';
import { MenuItem } from '@material-ui/core';

interface BtnProps {
  width: any;
  transparent?: boolean;
}

export const btnStyles = `
  display:flex;
  align-items:center;
  justify-content:center;
  border:0;
  padding:1rem;
  min-height:4.4rem;
  font-size:1.6rem;
  min-width:4.4rem;
  border-radius:1.2rem;
  transition:.2s;
  cursor:pointer;
  svg{
    margin-right:1rem;
  }
  &:focus{
    outline:none;
  }
  &[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const primaryBtnStyles = `
  color: ${white};
  background-color: ${accentColorPrim};
  text-decoration:none;
  min-width:12rem;
  &:hover,
  &:focus{
    
  }
`;

export const secondaryBtnStyles = `
  color: ${accentColorPrim};
  background-color: ${accentColorTertiary};
  &:hover,
  &:focus{
    outline:none;
  }
`;

export const StyledButtonPrimary = styled.button<
  Partial<CSS.Properties & BtnProps>
>`
  max-width: ${(props) => props.width};
  ${btnStyles};
  ${primaryBtnStyles}
`;

export const StyledButtonSecondary = styled.button<
  Partial<CSS.Properties & BtnProps>
>`
  max-width: ${(props) => props.width};
  ${btnStyles};
  ${secondaryBtnStyles}
`;

export const StyledButtonIcon = styled.button<
  Partial<CSS.Properties & BtnProps>
>`
  ${btnStyles};
  padding: 0;
  background-color: ${white};
  svg {
    margin: 0;
  }
`;

export const StyledButtonIconTransparent = styled.button<
  Partial<CSS.Properties & BtnProps>
>`
  ${btnStyles};
  padding: 0;
  background-color: transparent;
  svg {
    margin: 0;
  }
  width: ${(props) => (props.width ? props.width : 'auto')};
`;

export const StyledLinkButton = styled(Link)<
  Partial<CSS.Properties & BtnProps>
>`
  max-width: ${(props) => props.width};
  ${btnStyles}
  ${secondaryBtnStyles}
`;

export const StyledLinkButtonPrimary = styled(Link)<
  Partial<CSS.Properties & BtnProps>
>`
  max-width: ${(props) => props.width};
  ${btnStyles}
  ${primaryBtnStyles}
`;

export const StyledButtonTertiary = styled.button<
  Partial<CSS.Properties & BtnProps>
>`
  max-width: ${(props) => props.width};
  ${btnStyles}
  background-color: ${(props) => (props.transparent ? 'transparent' : white)};
  color: ${accentColorPrim};
`;

export const StyledButtonWarn = styled.button<
  Partial<CSS.Properties & BtnProps>
>`
  max-width: ${(props) => props.width};
  ${btnStyles}
  background-color: ${red};
  color: ${white};
`;

export const A = styled(Link)`
  ${btnStyles};
  width: auto;
`;

export const StyledMenuItem = styled(MenuItem)`
  font-size: 1.4rem;
`;
